
<!-- 查看明细 -->
<template>
  <div>
    <div class="title-content" style="display: flex;justify-content: flex-end;align-items: center;">
      <div class="reset-btn marginL12" @click="handleCancel">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</div>
    </div>
    <h-list-page class="level-container">
      <div class="item-module" style="margin-top: 16px;">
        <div class="title-style">{{ h_i18n('bc8a96444c0e3495d9042ebf356157a9') }}</div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="540" class="myTable" border
          :data="detailTable" size="small" style="width: 100%; min-height: 540px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: 16px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="plname" label="PL" width="100"></el-table-column>
          <el-table-column prop="mtlgroupname" :label="h_i18n('4e8365b7b7ef302d07d644229cb3055c')" width="160"></el-table-column>
          <el-table-column prop="mtlgroupcode" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
          <el-table-column :label="h_i18n('498bd05ebc689dfde8c4a3a59ace4a42')">
            <el-table-column prop="xcblnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="xcsqty" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="xcbll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="xcblpd" :label="h_i18n('56d13c9bc5aa3a2cdc814f062e9db601')" width="100"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('f69a6d4f90ebba688262bef0c8203920')">
            <el-table-column prop="sc3blnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="sc3sqty" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="sc3bll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="sc3blpd" :label="h_i18n('56d13c9bc5aa3a2cdc814f062e9db601')" width="100"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('a54a7311f43580647e349a0c3bdd339b')">
            <el-table-column prop="sc6blnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="sc6sqty" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="sc6bll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="sc6blpd" :label="h_i18n('56d13c9bc5aa3a2cdc814f062e9db601')" width="100"></el-table-column>
          </el-table-column>
          <el-table-column :label="h_i18n('bdc5aa5443d3244f514db4ab683a4210')">
            <el-table-column prop="sc12blnum" :label="h_i18n('111bf3546339b7d2a454e514828daf98')"></el-table-column>
            <el-table-column prop="sc12sqty" :label="h_i18n('a94af728555f1e79ba8993149a550a15')"></el-table-column>
            <el-table-column prop="sc12bll" :label="h_i18n('5448436a1fb8cfb12a23eaf558378eb4')"></el-table-column>
            <el-table-column prop="sc12blpd" :label="h_i18n('56d13c9bc5aa3a2cdc814f062e9db601')" width="105"></el-table-column>
          </el-table-column>
        </el-table>  
        <el-pagination background @current-change="handlePageChange"
          v-model:currentPage="currentPage" :page-size="10" style="display: flex;flex-direction: row;justify-content: flex-end;margin-right:50px;"
          layout="total, prev, pager, next,jumper" :total="currentTotal">
        </el-pagination>
      </div>
    </h-list-page>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  data(){
    return{
      currentPage:1,
      detailTable:[],
      currentTotal:0
    }
  },
  methods:{
    h_i18n,
    getDetailTable(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: "/base/userevaluation/QualityLevelInfo",
        data: {
          pageNo:this.currentPage||1,
          pageSize: 10,
          supplyCode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
          vcode: this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode,
        },
      }).then((res) => {
        this.closeLoading()
        this.detailTable = res.data.data.qlinfolist||[]
        this.currentTotal = res.data.data.resnum
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handlePageChange(val){
      this.currentPage = val
      this.getDetailTable()
    },
    handleCancel(){
      this.$router.go(-1)
    }
  },
  mounted(){
    this.getDetailTable()
  }
}
</script>

<style lang="scss" scoped>
.reset-btn{
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    background: rgba(22, 93, 255, 0.1);
  }
  &:active{
    color: #0E42D2;
    background: rgba(14, 66, 210, 0.1);
    border: 1px	solid rgb(14, 66, 210);
  }
}
.title-content{
  box-sizing: border-box;
  background: #fff;
  height: 56px;
  line-height: 56px;
  color: #1D2129;
  font-size: 18px;
  padding: 0 16px;
}
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}

.item-module{
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 13px 16px 16px;
}
.title-style{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: #1D2129;
  font-weight: bold;
}

</style>

<style>
.el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
  padding-left: 14px;
}
body .el-table .cell{
  text-align: left;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
  border-right: none;
}
.haier-list-page .el-table tr:nth-child(odd) td{
  background: #fff;
}
.haier-list-page .el-table .cell{
  padding-left: 16px !important;
}
</style>